import { calculateTimerColor } from "utils/timer";
import "./index.scss";

export const TimerHeader = ({ numberOfCards, seconds }) => {
  const m = Math.floor(seconds / 60);
  const s = Math.floor(seconds % 60);
  const padding = s < 10 ? "0" : "";

  const timeString = `${m}:${padding}${s}`;
  const text = `${numberOfCards} Card${numberOfCards > 1 ? "s" : ""} Reserved`;

  return (
    <div className="timer-header">
      {text}
      <span
        className="bubble"
        style={{
          backgroundColor: calculateTimerColor(seconds)
        }}
      >
        {timeString}
      </span>
    </div>
  );
};
